'use client'

import { useEffect, useState } from 'react'
import { SquareCodeIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const CodeBlock = () => {
  const { editor, sourceMode } = useEditorContext()
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (!editor) {
      return
    }

    const updateState = () => {
      setIsActive(editor.isActive('codeBlock'))
    }

    updateState()

    editor.on('selectionUpdate', updateState)
    editor.on('transaction', updateState)

    return () => {
      editor.off('selectionUpdate', updateState)
      editor.off('transaction', updateState)
    }
  }, [editor])

  const toggleCodeBlock = () => {
    editor.chain().focus().toggleCodeBlock().run()
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant={isActive ? 'default' : 'ghost'}
          title="Code Block"
          onClick={toggleCodeBlock}
          aria-pressed={isActive}
          disabled={sourceMode}
          tabIndex={-1}>
          <SquareCodeIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Code Block</p>
      </TooltipContent>
    </Tooltip>
  )
}

export default CodeBlock
